module.exports = __webpack_public_path__ + "97e239178957d2307692d82d8dfaf14a.pdf";